import { Box, FormControlLabel, Radio } from "@mui/material";
import "./skintype-item.css";
import _ from "lodash";

export default function SkinTypeItemComponent({skinType, imgSrc, value, label, definitions}: any): JSX.Element {
  return (
    <div className="skintype-item">
      <Box sx={{ display: { xs: 'none', sm: 'none', lg: 'flex' }}}>
        <img className="face" src={imgSrc}/>
        <div>
          <FormControlLabel className="label" value={value} control={<Radio disabled={skinType ? true : false}  />} label={label} />
          <ul>
            {_.map(definitions, (def) => (
              <li>{def}</li>
            ))}
          </ul>
        </div>
      </Box>

      <Box className="skintype-mobile" sx={{ display: { sm: 'flex', lg: 'none' }}}>
        <div className="face-label">
          <img className="face" src={imgSrc}/>
          <FormControlLabel className="label" value={value} control={<Radio disabled={skinType ? true : false}  />} label={label} />
        </div>
                                
        <ul>
          {_.map(definitions, (def) => (
            <li>{def}</li>
          ))}
        </ul>
      </Box>
                            
    </div>
  )
}